export default __webpack_public_path__ + "static/media/step3.850b4779.png";